import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
`

export const FullStarIcon = styled.svg`
    width: 1rem;
    height: 1rem;
`

export const HalfStarIcon = styled(FullStarIcon)``

export const EmptyStarIcon = styled(FullStarIcon)``
